module.exports = __webpack_public_path__ + "static/img/home_arrow.09476cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/home_arrow.png
// module id = 503
// module chunks = 2 3 4 5 6 8